export default __webpack_public_path__ + "assets/images/92c1280ac315151eaeac621e298194fb.svg";